import { $, $$ } from 'utils/dom';
import {
  hideCookiebanner,
  imprintLink,
  privacyPolicyLink,
  cookiebannerLabels,
  consentTypes,
} from './cookiebanner-variables';
import { Cookiebanner } from '@3pc/cookiebanner';
import { cookiebannerTemplateTablist } from './template-tablist';
import { ConsentOverlay, handleEmbed } from '@3pc/consent-overlay';

const consentOverlays = [];

const handleTicketEmbed = (container, enable) => {
  const id = container.id;
  const scriptsAlreadyCreated = document.body.querySelector(`#scriptTagTicket`);
  const contentContainer = $('.consent-overlay__iframe-html', container);
  const scriptTagContent = `
      window.TWEBSHOP = {
        config: 'berlinischegalerie_btm',
        language: 'de',
        theme: {
            sticky: {
                offset: 20,
                zIndex: 2
            }
        }
    }
  `;

  if (enable) {
    // create inline script tag at the end of <body> and paste in script content
    if (!scriptsAlreadyCreated) {
      const scriptTag = document.createElement('script');
      scriptTag.id = 'scriptTagTicket';
      const scriptTextNode = document.createTextNode(scriptTagContent);
      scriptTag.appendChild(scriptTextNode);

      const scriptLink = document.createElement('script');
      scriptLink.id = 'scriptLinkTicket';
      scriptLink.src =
        'https://twebshop.tomas-travel.com/app/experience/widget/app.js';

      document.body.appendChild(scriptTag);
      document.body.appendChild(scriptLink);
    }

    // create custom tag
    const widget = document.createElement('tws-experience-widget');
    widget.id = `widget-${id}`;
    widget.dataset.id = contentContainer.dataset.html;

    contentContainer.appendChild(widget);
  } else {
    // remove script and html
    if (scriptsAlreadyCreated) {
      const scriptTag = $('#scriptTagTicket');
      scriptTag.remove();
      const scriptLink = $('#scriptLinkTicket');
      scriptLink.remove();
    }
    const widget = $('#widget-' + id);
    widget && widget.remove();
    const shoppingcart = $('#twebshop');
    shoppingcart && shoppingcart.remove();
  }
};

const disableCookiebannerAt = [
  'https://berlinischegalerie.de/digital/audioguide-',
  'https://berlinischegalerie.de/digital/provenienzen/',
  'https://berlinischegalerie.de/digital/provenienzen-kunstwerke-wandern/',
  'https://berlinischegalerie.de/en/digital/provenienzen-kunstwerke-wandern/',
];

const disableCookiebanner = disableCookiebannerAt.some(url =>
  window.location.href.includes(url)
);

if (!disableCookiebanner) {
  new Cookiebanner({
    nameSpace: 'bg',
    consentButtonTypes: 'required-all',
    cookiebannerTemplate: cookiebannerTemplateTablist,
    labels: cookiebannerLabels,
    hideCookiebanner,
    imprintLink,
    privacyPolicyLink,
    consentTypes,
    onInit: () => {
      // init consent overlays
      const overlays = $$('[data-consent-type]');
      overlays.length &&
        overlays.forEach(overlay => {
          const consentOverlay = new ConsentOverlay({
            container: overlay,
            nameSpace: 'bg',
            onActivation: (container, consentType) => {
              if (consentType === 'embed') {
                handleEmbed(container, true);
              }
              if (consentType === 'tickets') {
                handleTicketEmbed(container, true);
              }
            },
            onDeactivation: (container, consentType) => {
              if (consentType === 'embed') {
                handleEmbed(container, false);
              }
              if (consentType === 'tickets') {
                handleTicketEmbed(container, false);
              }
            },
          });
          consentOverlay.init();
          consentOverlays.push(consentOverlay);
        });
    },
    onRender: banner => {
      // init cookiebanner tabpanel from custum template
      const tabButtons = document.querySelectorAll('.cookiebanner__tab');
      const tabPanels = document.querySelectorAll('.cookiebanner__tabpanel');

      // --- set first panel to active by default
      tabButtons[0].setAttribute('aria-selected', 'true');
      tabPanels[0].setAttribute('aria-hidden', 'false');

      tabButtons.forEach(tabButton => {
        tabButton.addEventListener('click', () => {
          const target = tabButton.getAttribute('aria-controls');

          // reset all
          tabButtons.forEach(tabButton =>
            tabButton.setAttribute('aria-selected', 'false')
          );
          tabPanels.forEach(tabPanel =>
            tabPanel.setAttribute('aria-hidden', 'true')
          );

          // set selected tab to active
          tabButton.setAttribute('aria-selected', 'true');
          document
            .querySelector(`#${target}`)
            .setAttribute('aria-hidden', 'false');
          document.querySelector(`#${target}`).focus();
        });
      });
      // TODO: fix this workaround
      const closeBtns = $$('.cookiebanner [data-consent]');
      closeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          window.location.reload();
        });
      });
    },
    onOptIn: cookie => {
      consentOverlays.forEach(overlay => {
        if (overlay.consentType === cookie.type) {
          overlay.toggleAll();
        }
      });
    },
    onOptOut: cookie => {
      consentOverlays.forEach(overlay => {
        if (overlay.consentType === cookie.type) {
          overlay.toggleAll();
        }
      });
    },
  }).init();
}
